import { Routes } from '@tcs/create-account/utils/routes';

export const getDocumentRouteById = (id: string): string | undefined =>
  Object.values(Routes).find((doc) => doc.id === id)?.route;
